import * as React from 'react'
// components
import PlanDetails from 'components/PageComponents/Plans/Edit/components/SidebarInfo'
import PlanDetailsAPI from 'containers/Plan/Details/layers/API/index'

const PlanEditContainer: React.FC<{ planId?: string }> = ({ planId }) => (
  <PlanDetailsAPI planId={planId}>
    <PlanDetails />
  </PlanDetailsAPI>
)

export default PlanEditContainer
